<template>
  <div>
    <div style="display: none">
      <input type="file" id="f1" v-on:change="fileImg()">
    </div>
    <div style="background-color: white; padding: 15px;">
      <div style="padding-bottom: 15px; border-bottom: 1px solid #e7e7e7">
        <span style="font-size: 13px; color:#97a8be">首页 / 文章管理 / 文章列表 / 添加文章</span>
      </div>
      <div style="padding-top: 15px;">
        <table width="100%">
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>标题
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="data.title" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              图片
            </td>
            <td style="text-align: left;padding-left: 15px; overflow: hidden; padding-top: 15px;">

              <img :src="imgUrl+data.img" style="height: 100px; vertical-align: middle" />
              <input type="button" value="上传图片" class="addBtn" style="margin-left:20px;vertical-align: middle; float: none" onclick="f1.click()" />
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>序列号
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="data.num" type="number" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>文章类型
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <select class="boxText" v-model="data.type" style="width: 200px;">
                <option value="平台">平台</option>
                <option value="新闻">新闻</option>
                <option value="公告">公告</option>
                <option value="其他">其他</option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              发布者
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="data.user" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              文章详情
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;height: 600px">
              <VueEditor v-model="data.note" style="width: 100%; height: 500px" />
            </td>
          </tr>

        </table>
      </div>

      <div style="padding-top: 15px; padding-bottom: 25px; padding-left: 150px">
        <input @click="addAdmin" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #1890ff; border: 1px solid #1890ff; color: white" value="添加" />
        <input @click="goback" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #ffffff; border: 1px solid #dbdbdb; margin-left: 15px; color: #606266" value="返回" />
      </div>
    </div>

  </div>
</template>

<script>

import {closeLoading, DO_NET_URL, loading, toask} from "@/config/config";
import {axiosFile, axiosGet, axiosPost, axiosPostJson} from "@/main";
import { VueEditor } from "vue2-editor";

export default {
  name: "AddNews",
  components:{
    VueEditor
  },
  data(){
    return{
      data:{
        title: "",
        img: "",
        num: 0,
        type: "平台",
        note: "",
        user: ""
      },
      imgUrl:"",
      content:""
    }
  },
  mounted(){
    let that=this
    if(localStorage.getItem("iwa_token")==null||localStorage.getItem("iwa_token")==""){
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }
  },
  methods: {
    addAdmin(){
      let that=this
      if(this.data.title==""){
        toask("请输入标题！",6)
        return
      }
      loading("请求中")
      axiosPostJson(DO_NET_URL+"News/AddNew",JSON.stringify(this.data),function (res){
        closeLoading()
        if(res.code==200){
          toask("添加成功",6)
          setTimeout(function (){
            that.$emit("send",'newsList')
          },600)
        }else{
          toask(res.data,6)
        }
      })
    },
    fileImg: function () {
      var that = this;
      var formData = new FormData();
      formData.append("files", document.querySelector('#f1').files[0]);
      axiosFile(DO_NET_URL + "other/UploadImg",formData,function (res){
        console.log(res)
        if(res.code==200){
          that.data.img=res.data.img
          that.imgUrl=res.data.url
        }else{
          toask(res.data,6)
        }
        document.getElementById('f1').value=''
      })

    },
    goback(){
      this.$emit("send",'newsList')
    },

  }
}
</script>

<style scoped>
.boxText{-webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  height: 40px;
  /*line-height: 40px;*/
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 50%;}
.leftTd{text-align: right;
  vertical-align: middle;
  font-size: 12px;
  color: #606266;
  line-height: 40px;
  padding: 15px 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;font-weight: 700; width: 120px}
.addBtn{color: #1890ff;background: #e8f4ff; border: 1px solid #1890ff; cursor: pointer; float: left; font-size: 12px;padding: 7px 15px;border-radius: 3px;}
.th{border-bottom:1px solid #dfe6ec; text-align: left; padding:0 10px;word-break: break-word;background-color: #f8f8f9;color: #515a6e;height: 40px;font-size: 12px;}
.td{border-bottom:1px solid #dfe6ec;padding:0 10px; word-break:break-word;background-color: #ffffff;color: #606266;height: 40px;font-size: 12px;}
</style>